module.exports = __webpack_public_path__ + "static/media/user-graduate.1a435b7c.svg";